import Data from './index';

import { format, formatReact } from 'utils/format';

export function localeFunction(table, ...names) {
  function translate(str){
    for (let tbl of names) {
      const res = table[tbl] && table[tbl][str];
      if (res) return res;
    }
    return table[str] || str;
  }

  return function(strings, ...args) {
    if (!strings) return strings;
    let src = strings;
    if (Array.isArray(strings)) {
      src = strings.map((str, index) => (index ? `{${index - 1}}` : "") + str.replace(/[{}]/g, "\\$&")).join("");
    }
    src = translate(src);
    if (args.some(x => typeof x === "object")) {
      return formatReact(src, ...args);
    } else {
      return format(src, ...args);
    }
  }
}

export default function Locale(...names) {
  let func = null;
  return function(...args) {
    if (!func) {
      if (!Data.localeTable) {
        throw Error("data is not loaded yet");
      }
      func = localeFunction(Data.localeTable, ...names);
    }
    return func(...args);
  };
}
